import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X4UnitStore} from '../X4UnitStore';

@observer
export class AddLessonControls extends React.Component<{ store: X4UnitStore }> {
  render() {
    const {store} = this.props;
    if (store.addLesson === null)
      return null;

    const addLesson = store.addLesson;
    const isPending = addLesson.save?.isPending === true;

    return (<>
      <div className="row justify-content-end" key="add-form-actions">
        <div className="col-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeAdd}
                  disabled={isPending}>
            Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}>
            Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={addLesson.save} align="right"/>
    </>);
  }
}
